import React from "react";
import { useModelStore } from "../../store/useModelStore";

interface FileMenuProps {
  onMenuItemClick?: () => void;
  onNewProjectClick?: () => void;
  onSaveProjectClick?: () => void;
  onSaveProjectAsClick?: () => void;
  onLoadProjectClick?: () => void;
  onRecentProjectsClick?: () => void;
  hasProject?: boolean;
  hasDrawnData?: boolean;
}

const FileMenu: React.FC<FileMenuProps> = ({
  onMenuItemClick,
  onNewProjectClick,
  onSaveProjectClick,
  onSaveProjectAsClick,
  onLoadProjectClick,
  onRecentProjectsClick,
  hasProject = false,
  hasDrawnData = false,
}) => {
  const isElectron = typeof window !== "undefined" && window.electronAPI;

  const handleNewProjectClick = () => {
    if (onMenuItemClick) onMenuItemClick();
    if (onNewProjectClick) onNewProjectClick();
  };

  const handleSaveClick = () => {
    if (onMenuItemClick) onMenuItemClick();
    if (onSaveProjectClick) onSaveProjectClick();
  };

  const handleSaveAsClick = () => {
    if (onMenuItemClick) onMenuItemClick();
    if (onSaveProjectAsClick) onSaveProjectAsClick();
  };

  const handleLoadClick = () => {
    if (onMenuItemClick) onMenuItemClick();
    if (onLoadProjectClick) onLoadProjectClick();
  };

  const handleRecentProjectsClick = () => {
    if (onMenuItemClick) onMenuItemClick();
    if (onRecentProjectsClick) onRecentProjectsClick();
  };

  // Determine if Save buttons should be enabled
  const canSave = hasProject || hasDrawnData;

  return (
    <div className="absolute top-full left-0 mt-1 w-56 bg-gray-800 border border-gray-700 rounded shadow-lg z-50">
      <button
        onClick={handleNewProjectClick}
        className="w-full text-left px-4 py-2 hover:bg-gray-700 text-gray-200 text-sm"
      >
        New Project
      </button>

      <div className="border-t border-gray-700"></div>

      <button
        onClick={handleRecentProjectsClick}
        className="w-full text-left px-4 py-2 hover:bg-gray-700 text-gray-200 text-sm"
      >
        Recent Projects
      </button>

      <div className="border-t border-gray-700"></div>

      <button
        onClick={handleLoadClick}
        className="w-full text-left px-4 py-2 hover:bg-gray-700 text-gray-200 text-sm"
      >
        Load Project
      </button>

      <div className="border-t border-gray-700"></div>

      <button
        onClick={handleSaveClick}
        disabled={!canSave}
        className={`w-full text-left px-4 py-2 text-sm flex justify-between items-center ${
          canSave
            ? "hover:bg-gray-700 text-gray-200"
            : "text-gray-500 cursor-not-allowed opacity-50"
        }`}
      >
        <span>Save Project</span>
        <span className="text-xs text-gray-500">Ctrl+S</span>
      </button>

      <div className="border-t border-gray-700"></div>

      <button
        onClick={handleSaveAsClick}
        disabled={!canSave}
        className={`w-full text-left px-4 py-2 text-sm flex justify-between items-center whitespace-nowrap ${
          canSave
            ? "hover:bg-gray-700 text-gray-200"
            : "text-gray-500 cursor-not-allowed opacity-50"
        }`}
      >
        <span className="whitespace-nowrap">Save Project As</span>
        <span className="text-xs text-gray-500 ml-2">Ctrl+Shift+S</span>
      </button>
    </div>
  );
};

export default FileMenu;
